export const menuDesktop = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const menuDesktop = document.querySelector('.wp-block-kadence-header-desktop');
    if (!menuDesktop) return;

    document.querySelectorAll('.wp-block-kadence-header-desktop .wp-block-kadence-navigation .sub-menu').forEach(submenu => {
      if (!submenu.querySelector('.submenu-bg')) {
        const bg = document.createElement('div');
        bg.classList.add('submenu-bg');
        submenu.prepend(bg);
      }
    });

    document.querySelectorAll('.wp-block-kadence-header-desktop .wp-block-kadence-navigation .submenu-bg').forEach(bg => {
      bg.addEventListener('mouseenter', function() {
        const li = this.closest('.menu-item.menu-item-has-children');
        if (!li) return;
        li.classList.add('hide-hover');

        setTimeout(() => li.classList.remove('hide-hover'), 100);
      });
    });
  });
};